import { TableColumn } from '../../table/DataTable.types';

export const columns = (handleSelect: any) =>
  [
    {
      accessor: 'code',
      name: 'page.invoice.vat-code.col-code',
      hideFilter: true,
      cellRenderer(e) {
        return (
          <span
            onClick={(e: any) => handleSelect(e.target.innerText)}
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            {e.code}
          </span>
        );
      },
    },
    {
      accessor: 'type',
      name: 'page.invoice.vat-code.col-type',
    },
    {
      accessor: 'location',
      name: 'page.invoice.vat-code.col-location',
    },
    {
      accessor: 'regime',
      name: 'page.invoice.vat-code.col-regime',
    },
    {
      accessor: 'rate',
      name: 'page.invoice.vat-code.col-rate',
    },
    {
      accessor: 'coefficientPercent',
      name: 'page.invoice.vat-code.col-koef',
      cellRenderer(e) {
        return <span>{e.coefficientPercent}%</span>;
      },
    },
  ] as TableColumn[];
